export const PRIMARY = '#52c41a';
export const SECONDARY = 'rgb(0, 200, 83)';
export const DANGER = '#ff4d4f';
export const SUCCESS = '#52c41a';
export const BGPRIMARY = 'rgb(248, 251, 252)';
export const CenterFlex = 'd-flex justify-content-center align-items-center';
;
export const ErrorExtractor = (error) => {
  if (error.response) {
    return error.response.data.message || error.response.data.error || 'An error occurred';
  } else if (error.request) {
    return 'No response received from the server';
  } else {
    return error.message || 'An unexpected error occurred';
  }
}